import * as React from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Chip,
  IconButton,
  Modal,
  Typography,
} from "@mui/material";
import { useDataContext } from "../../context/DataContext";
import DetalhadoTable from "./DetalhadoTable";
import CloseIcon from "@mui/icons-material/Close";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const boxStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: "95%", md: "85%", lg: "65%" },
  height: { xs: "90%", md: "80%", lg: "70%" },
  backgroundColor: "#f5f5f5",
  // backgroundColor: "white",
  border: "solid 6px darkgray",
  borderRadius: "8px",
  p: 4,
  outline: "unset !important",
  display: "flex",
  flexDirection: "column",
};

interface ModalProps {
  open: boolean;
  onClose: () => void;
  hospital: string;
  especialidade: string;
}

const DetalhadoModal: React.FC<ModalProps> = ({
  open,
  onClose,
  hospital,
  especialidade,
}) => {
  const { detalhado } = useDataContext();

  interface Item {
    id: number;
    i_desc_local_passagem: string;
    i_desc_local_passagem_completa: string;
    i_num_passagem: string;
    i_class_risco: string;
    i_data_hora_entrada: string;
    i_data_hora_reg_prim_atend: string | null;
    i_data_hora_triagem: string;
    i_data_hora_saida: string | null;
    i_motivo_saida: string | null;
    data_extracao: string;
  }

  const detalhadoHospital = detalhado[hospital] || {};
  const detalhadoHospitalEspecialidade = detalhadoHospital[especialidade] || {};

  const filtrarPorClassificacaoRisco = (risco: string) => {
    return Object.values(detalhadoHospitalEspecialidade).filter(
      (item) => (item as Item).i_class_risco === risco
    );
  };

  const laranja = filtrarPorClassificacaoRisco("02 - Laranja");
  const amarelo = filtrarPorClassificacaoRisco("03 - Amarelo");
  const verde = filtrarPorClassificacaoRisco("04 - Verde");
  const azul = filtrarPorClassificacaoRisco("05 - Azul");

  const cores = {
    laranja: "#E96F19",
    amarelo: "#ffce24",
    verde: "#077d04",
    azul: "#007bff",
  };

  const grupos = [
    { label: "Laranja", cor: cores.laranja, rows: laranja },
    { label: "Amarelo", cor: cores.amarelo, rows: amarelo },
    { label: "Verde", cor: cores.verde, rows: verde },
    { label: "Azul", cor: cores.azul, rows: azul },
  ];

  const accordionSx = {
    borderTop: "1px solid rgba(0,0,0,0.12)",
    borderBottom: "1px solid rgba(0,0,0,0.12)",
    "&.Mui-expanded": {
      borderTop: "1px solid rgba(0,0,0,0.12)",
      borderBottom: "1px solid rgba(0,0,0,0.12)",
      margin: 0,
    },
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={boxStyle}>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: "1rem",
            top: "1rem",
          }}
        >
          <CloseIcon />
        </IconButton>
        <Typography align="center" variant="h5">
          {hospital} - {especialidade}
        </Typography>

        <Typography align="center" variant="h6" mb={2}>
          Pacientes aguardando atendimento (agora)
        </Typography>

        <Box
          sx={{
            flexGrow: 1,
            overflowY: "scroll",
            pr: 1,
          }}
        >
          {grupos.map((grupo) => (
            <Accordion key={grupo.label} sx={accordionSx}>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography sx={{ color: grupo.cor, fontWeight: "bold" }}>
                  {grupo.label}
                </Typography>
                <Chip
                  label={grupo.rows.length}
                  size="small"
                  sx={{
                    ml: 1,
                    color: "white",
                    backgroundColor: grupo.cor,
                  }}
                />
              </AccordionSummary>
              <AccordionDetails sx={{ pt: 0, pb: 0 }}>
                <DetalhadoTable color={grupo.cor} rows={grupo.rows} />
              </AccordionDetails>
            </Accordion>
          ))}
        </Box>
      </Box>
    </Modal>
  );
};

export default DetalhadoModal;
